import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-contracts-type',
  templateUrl: './edit-contracts-type.component.html',
  styleUrls: ['./edit-contracts-type.component.scss']
})
export class EditContractsTypeComponent implements OnInit {

    productId: string | null = null;


  product: any = {

    name_ar: '',
    name_en: '',
  };



constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,
        private translate: TranslateService
  ) {}
    ngOnInit(): void {
    // get product id from route
    this.productId = this.route.snapshot.paramMap.get('id');

    if (this.productId) {
      this.loadProduct(this.productId);
    }
  }

  // Fetch product details (create an API if not exists)
 loadProduct(id: string): void {
    this.apiService.getContractstypeById(id).subscribe({
      next: (res: any) => {
        this.product = res?.data || this.product;
      },
      error: (err) => {
        console.error('Failed to load product:', err);
        // this.toastr.error('Failed to load product details');
      },
    });
  }

    onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      this.product.image = event.target.files[0];
    }
  }
  // Update product

  
updateProduct(): void {
  if (!this.productId) {
    this.toastr.error(this.translate.instant('MENU.DASHBOARD.missing_id'));
    return;
  }

  const payload = {
    name_ar: this.product.name_ar?.trim() || '',
    name_en: this.product.name_en?.trim() || ''
  };

  this.apiService.editContractstType(this.productId, payload).subscribe({
    next: () => {
      this.toastr.success(this.translate.instant('MENU.DASHBOARD.record_updated_successfully'));
      this.router.navigate(['/contracts-type']);
    },
    error: (err) => {
      console.error('Update failed:', err);

      if (err.error?.errors) {
        const errors = err.error.errors;
        Object.keys(errors).forEach(key => {
          this.toastr.error(errors[key][0]);
        });
      } else {
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_update_record'));
      }
    },
  });
}



  // updateProductt(): void {
  //   if (!this.productId) return;

  //   if (
  //     this.product.password &&
  //     this.product.password !== this.product.password_confirmation
  //   ) {
  //     this.toastr.error('Passwords do not match');
  //     return;
  //   }

  //   const form = new FormData();
  //   form.append('name', this.product.name);
  //   form.append('email', this.product.email);
  //   form.append('mobile', this.product.mobile);

  //   if (this.product.password) {
  //     form.append('password', this.product.password);
  //     form.append('password_confirmation', this.product.password_confirmation);
  //   }

  //   if (this.product.image) {
  //     form.append('image', this.product.image);
  //   }

  //   this.apiService.editreproductions(this.productId, form).subscribe({
  //     next: () => {
  //       this.toastr.success('User updated successfully');
  //       this.router.navigate(['/users']);
  //     },
  //     error: (err) => {
  //       console.error('Update failed:', err);
  //       this.toastr.error('Failed to update user');
  //     }
  //   });
  // }

}